import { rgb } from '../helpers';
import { BLACK, LIGHT_GREY } from '../theme/color';

export const overrides = {
    MuiTypography: {
        root: {
            '&.NeptuneTypography-breadCrumb-current': {
                color: `rgba(${rgb(BLACK)}, .88)`
            },
            '&.NeptuneTypography-breadCrumb-inactive': {
                color: `rgba(${rgb(LIGHT_GREY)}, .6)`
            }
        }
    }
};
